import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { useYwuApp } from '../../../contexts/ywu-app-context';
import { getTalkingPointsForDomicileByTopicId, type TalkingPointDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useContentByTopicIdAndDomicile(topicId?: number): UseQueryResult<TalkingPointDto[], AxiosError> {
    const { activeDomicile } = useYwuApp();
    const queryKey = useMemo(() => queryKeys.contentByTopicIdAndDomicile(topicId, activeDomicile), [activeDomicile, topicId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) =>
            getTalkingPointsForDomicileByTopicId({ path: { topicId: topicId! }, query: { domicile: activeDomicile }, signal }).then((result) => result.data),
        enabled: !!topicId,
    });
}
